module.exports = "https://www.gc-pro.gnp.com.mx/2aa30dc218e7ff3018df71ed90fd124d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/help_outline_24px@2x.svg
// module id = 8115
// module chunks = 0